import React from 'react';
import logger from './Logger/logger';

import Error404 from "../Error/error404";
import Error403 from "../Error/error403";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: false,
            errorInfo: false,
        };
    }

    static getDerivedStateFromError(error, errorInfo) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error, errorInfo: errorInfo };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        if (!error.message.startsWith('404') && !error.message.startsWith('403') && !error.message.includes('Loading chunk') && window.location.protocol === 'https:') {
            logger.push({
                orientation: window.screen.orientation,
                location: window.location,
                error: new String(error),
                info: errorInfo,
            });
        } else {
            console.log(error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            if (this.state.error.message.startsWith('404')) {
                return (
                    <Error404 />
                )
            }

            if (this.state.error.message.startsWith('403')) {
                return (
                    <Error403 />
                )
            }

            if (this.state.error.message.includes('Loading chunk')) {
                window.location.reload()
            }

            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    padding: '32px 16px',
                    textAlign: 'center',
                    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                }}>
                    <h2 style={{ fontSize: '22px', fontWeight: '600', marginBottom: '12px', color: '#1a1a1a' }}>
                        Упс, произошла непредвиденная ошибка
                    </h2>
                    <p style={{ fontSize: '16px', color: '#666', marginBottom: '24px', maxWidth: '400px' }}>
                        Попробуйте перезагрузить страницу или зайдите позже.
                    </p>
                    <button
                        onClick={() => window.location.href = process.env.REACT_APP_ENV === 'local' ? process.env.REACT_APP_LOCAL_BASIC : process.env.REACT_APP_BASIC}
                        style={{
                            padding: '10px 24px',
                            fontSize: '15px',
                            fontWeight: '500',
                            backgroundColor: '#3c8224',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                        }}
                    >
                        Вернуться на главную
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}